<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Trip_Title' | translateWF: 'Trips' }}</h1>
        <div class="page__title_buttons">
          @if (canCreate) {
            <p-button [label]="'Trip_New' | translateWF: 'New trip'" icon="pi pi-plus" (click)="createTrip()" />
          }
        </div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{ 'Trip_Subtitle' | translateWF: 'Employee trips. Creating a trip posts nothing.' }}
      </p>
    </div>

    <div class="cs-summary-grid">
      <p-card data-variant="summary" [header]="'Trip_Kpi_Open' | translateWF: 'Open trips'">
        <ng-template pTemplate="subtitle">{{ summary()?.open ?? 0 }}</ng-template>
        {{ 'Trip_Kpi_Open_Unit' | translateWF: 'ready for advances and receipts' }}
      </p-card>
      <p-card data-variant="summary" data-severity="warning" [header]="'Trip_Kpi_ToApprove' | translateWF: 'To approve'">
        <ng-template pTemplate="subtitle">{{ summary()?.toApprove ?? 0 }}</ng-template>
        {{ 'Trip_Kpi_ToApprove_Unit' | translateWF: 'waiting for you' }}
      </p-card>
      <p-card data-variant="summary" [header]="'Trip_Kpi_Submitted' | translateWF: 'Submitted'">
        <ng-template pTemplate="subtitle">{{ summary()?.submitted ?? 0 }}</ng-template>
        {{ 'Trip_Kpi_Submitted_Unit' | translateWF: 'in approval' }}
      </p-card>
      <p-card data-variant="summary" [header]="'Trip_Kpi_InSettlement' | translateWF: 'In settlement'">
        <ng-template pTemplate="subtitle">{{ summary()?.inSettlement ?? 0 }}</ng-template>
        {{ 'Trip_Kpi_InSettlement_Unit' | translateWF: 'with an expense claim' }}
      </p-card>
    </div>

    <div class="cs-page-list-grid">
      @if (showFilters() && filterConfig(); as config) {
        <div>
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'Trip_Title' | translateWF: 'Trips'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-tabs [value]="scope()" (valueChange)="setScope($event)">
            <p-tablist>
              <p-tab [value]="scopes.All">{{ 'Trip_Tab_All' | translateWF: 'All' }}</p-tab>
              <p-tab [value]="scopes.Mine">{{ 'Trip_Tab_Mine' | translateWF: 'My trips' }}</p-tab>
              <p-tab [value]="scopes.ToApprove">
                {{ 'Trip_Tab_ToApprove' | translateWF: 'To approve' }}
                @if ((summary()?.toApprove ?? 0) > 0) {
                  <p-tag [value]="(summary()?.toApprove ?? 0).toString()" severity="warn" />
                }
              </p-tab>
            </p-tablist>
          </p-tabs>

          <p-table [value]="items()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number" style="width: 13rem">
                  {{ 'Trip_Col_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="number" />
                </th>
                <th pSortableColumn="employee">
                  {{ 'Trip_Field_Employee' | translateWF: 'Employee' }}
                  <p-sortIcon field="employee" />
                </th>
                <th pSortableColumn="destination">
                  {{ 'Trip_Field_Destination' | translateWF: 'Destination' }}
                  <p-sortIcon field="destination" />
                </th>
                <th pSortableColumn="departureDate" style="width: 13rem">
                  {{ 'Trip_Col_Dates' | translateWF: 'Dates' }}
                  <p-sortIcon field="departureDate" />
                </th>
                <th>{{ 'Trip_Field_Purpose' | translateWF: 'Purpose' }}</th>
                <th>{{ 'Trip_Field_CostCenter' | translateWF: 'Cost center' }}</th>
                <th pSortableColumn="status" style="width: 9rem">
                  {{ 'Status' | translateWF: 'Status' }}
                  <p-sortIcon field="status" />
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let row = getRow(rowData);
              <tr>
                <td>
                  <a class="cs-table-link font-mono" (click)="redirectToDetails(row.id)">{{ row.number }}</a>
                </td>
                <td>{{ row.employee.name }}</td>
                <td>{{ row.destination }}</td>
                <td class="tabular-nums">{{ row.departureDate | date: 'yyyy-MM-dd' : 'UTC' }} → {{ row.returnDate | date: 'yyyy-MM-dd' : 'UTC' }}</td>
                <td>{{ row.purpose }}</td>
                <td>{{ row.costCenter.code }} · {{ row.costCenter.name }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center">{{ 'Trip_Empty' | translateWF: 'No trips found.' }}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
